import type { ComponentProps } from 'react'
import { Container } from '@/components/container'

type PageLayoutProps = ComponentProps<'div'>

import { tv } from '@/libs/tv'

const pageLayoutStyles = tv({
	base: [
		'grid',
		'has-[.breakout]:[--pi:0rem] [--pi:calc((--spacing(6.25))-0.25rem)]',
		'[--c-max-w:(--spacing(360))]',
		'[--b-max-w:(--spacing(720))]',
	],
})

const PageLayout = ({ className, children, ...props }: PageLayoutProps) => (
	<Container className={pageLayoutStyles({ class: className })} data-id='page-layout' {...props}>
		{children}
	</Container>
)

const PageLayoutContainer = ({ className, children, ...props }: PageLayoutProps) => (
	<div className={tv({ base: 'w-full grid grid-rows-1 auto-cols-auto gap-4 py-4' })({ class: className })} {...props}>
		{children}
	</div>
)

export { PageLayout, PageLayoutContainer }
